import React, { useState, useEffect } from 'react'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ManageDurableArticlesWidget from '../../../widgets/durableArticlesWidget/manageDurableArticles/ManageDurableArticlesWidget'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { getAssetClosureById } from '../../../redux/actions/accountingAssetClosure'
import { ASSET_CLOSURE_STEP } from '../../../constants/assetClosureStep'

//จัดการครุภัณฑ์-ปิดโครงการ
export default function ClosureRequestDurableArticles() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')
  const assetClosureId = sessionGetItemStr('assetClosureId')
  const assetClosureStep = sessionGetItemStr('assetClosureStep')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getAssetClosureById(
        projectCode,
        assetClosureId,
        assetClosureStep || ASSET_CLOSURE_STEP.USER
      )
      console.log('response =>  ', response)
      setSchema(response.model)

      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </div>
    )
  }

  if (!schema || isLoading) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <PanalLoadingTemplate />
      </div>
    )
  }

  return (
    <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar />
      <ContentHeader
        header={schema.header}
        subHeader={''}
        isNotCallApi
        isShowGoButton
        cleanSessions={['assetClosureId']}
      />

      <ManageDurableArticlesWidget
        schema={schema}
        //isEdit={!schema.disabled && assetClosureStep == 0}
        step={assetClosureStep}
      />
      <br />
    </div>
  )
}
